/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, computed } from '@angular/core';
import { dataChatService } from 'src/chatbot/service/dataChat.service';
import { SendMessageService } from 'src/chatbot/service/sendMessage.service';

@Component({
  selector: 'recommended-messages',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './recommendedMessages.component.html',
  styleUrl: './recommendedMessages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendedMessagesComponent {
  public dataChat = inject(dataChatService)
  public sendMessage = inject(SendMessageService)

  handleClick(message: string){
    this.sendMessage.sendMessageWebSocket(message);
  }

 }